import { useQuery, useQueryClient } from '@tanstack/react-query';
import { gql, apiLogout } from './api';
import { clearSession } from './accounts';
import type { ChosenSuperconnector } from '@ah/people/shared';

export interface Me {
  id: string;
  name: string;
  email: string;
  pictureUrl: string | null;
  linkedinUrl: string | null;
  linkedinUrlVerified: boolean;
  isAdmin: boolean;
  givenName: string | null;
  familyName: string | null;
  headline: string | null;
  about: string | null;
  locationRaw: string | null;
  followerCount: number | null;
  connectionCount: number | null;
  backgroundPictureUrl: string | null;
  openToWork: boolean | null;
  lastSyncedAt: string | null;
  syncStatus: string | null;
  onboardedAt: string | null;
  chosenSuperconnector: ChosenSuperconnector | null;
}

const ME_QUERY = /* GraphQL */ `
  query Me {
    me {
      id
      name
      email
      pictureUrl
      linkedinUrl
      linkedinUrlVerified
      isAdmin
      givenName
      familyName
      headline
      about
      locationRaw
      followerCount
      connectionCount
      backgroundPictureUrl
      openToWork
      lastSyncedAt
      syncStatus
      onboardedAt
      chosenSuperconnector {
        firstName
        lastName
        pictureUrl
        gender
      }
    }
  }
`;

const AUTH_ME_KEY = ['auth', 'me'] as const;

export function useMe() {
  const qc = useQueryClient();
  const q = useQuery({
    queryKey: AUTH_ME_KEY,
    queryFn: async () => {
      const data = await gql.request<{ me: Me | null }>(ME_QUERY);
      return data.me;
    },
  });

  async function logout() {
    await apiLogout();
    clearSession();
    qc.setQueryData(AUTH_ME_KEY, null);
    qc.setQueryData(['me'], null);
    window.location.href = '/';
  }

  return { ...q, logout };
}
